module.exports = __webpack_public_path__ + "static/media/FB4@2x.b682a380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/FB/FB4@2x.png
// module id = 639
// module chunks = 0